import script from "./SuporteComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SuporteComponent.vue?vue&type=script&setup=true&lang=js"

import "./SuporteComponent.vue?vue&type=style&index=0&id=55632fbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55632fbc"]])

export default __exports__